const logotypeAnimated = document.querySelectorAll('.header__heading-animation .js-logotype--animated');
let hasAnimated = false;

window.addEventListener('scroll', () => {
  if (window.scrollY > 1 && !hasAnimated) {
    hasAnimated = true;

    logotypeAnimated.forEach((elem, i) => {
      const svgPaths = elem.querySelectorAll('path');

      svgPaths.forEach((path, i) => {
        gsap.to(path, {
          duration: 3,
          physics2D: {
            angle: 270 + gsap.utils.random(-20, 20), // Angle closer to straight down
            velocity: gsap.utils.random(50, 150), // Lower initial velocity
            gravity: 900,
          },
          rotation: gsap.utils.random(-90, 90),
          ease: "power3.inOut",
          delay: 0 + (i * 0.025),
          
          // add class to body on complete
          onComplete: () => {
            document.body.classList.add('has-animated');
          }
        });
      });
    });
  }
});